<template>
  <v-app>
    <template v-if="isNotApp">
      <v-main>
        <router-view/>
      </v-main>
    </template>

    <template v-else>
      <!-- HEADER: sincroniza isMini por .sync -->
      <AppBar :isMini.sync="isMini" @toggle-drawer="drawer = !drawer" />

      <!-- DRAWER / NAV recebe o estado atual -->
      <Nav v-model="drawer" :isMini="isMini" :user_data="getUserData" @ticket="createTicket=true"/>

      <Tickets
        @close-success="success=true; createTicket=false;"
        @close="createTicket=false"
        :openDialog="createTicket"
      />

      <SuccessSnackbar message="Ticket criado com sucesso!" v-model="success"/>

      <Main @user-data="userDataMethod" />

      <Footer @open-hall-of-fame="openHallOfFameEvent" />
    </template>

    <!-- Diálogo de atualização -->
    <v-dialog v-model="updateExists" width="25%">
      <v-card>
        <v-card-title class="primary white--text">Atualização!</v-card-title>
        <v-card-text class="mt-4">
          Existe uma atualização disponível e, para ter acesso a todas as funcionalidades (inclusive correção de erros) deverá atualizar a aplicação!
        </v-card-text>
        <v-card-actions>
          <v-btn class="success" text @click="refreshApp" style="display: block; margin: auto;">
            Atualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Hall of Fame -->
    <v-dialog
      v-model="openHallOfFame"
      width="30%"
      content-class="pa-0 ma-0"
      scrollable
    >
      <HallOfFame @close="openHallOfFame=false;" />
    </v-dialog>
  </v-app>
</template>

<script>
import AppBar from "@/components/UI/Template/AppBar";
import SuccessSnackbar from "@/components/UI/Snackbars/SuccessSnackbar";
import Tickets from "@/views/Tickets/Tickets.vue";
import Nav from "@/components/UI/Template/Nav";
import Main from "@/components/UI/Template/Main";
import Footer from "@/components/UI/Template/Footer";
import update from "./mixins/update";
import HallOfFame from "@/views/HallOfFame.vue";

export default {
  name: "App",
  mixins: [update],
  components: {
    HallOfFame,
    AppBar,
    Nav,
    Main,
    Footer,
    Tickets,
    SuccessSnackbar,
  },
  data: () => ({
    mini: null,
    openHallOfFame: false,
    drawer: false,   // 👈 FALTAVA
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight,
    createTicket: false,
    success: false,
    userData: null,
  }),
  mounted() {
  },
  methods: {
    openHallOfFameEvent() {
      this.openHallOfFame = true;
    },
    userDataMethod(data) {
      this.userData = data;
    },
  },
  computed: {
    getUserData() {
      return this.userData;
    },
    isNotApp() {
      const names = [
        "login-credentials",
        "login",
        "page404",
        "page500",
        "reset",
        "mfa",
        "verify",
        "verify_microsoft",
        "Registo Diário Manobrador",
        "Registo Diário Manobrador User type",
        "Registo Diário Encarregado",
        "Registo Diário Encarregado Hash",
        "Edição Diário Dia",
        "HallOfFame",
      ];
      return names.indexOf(this.$route.name) >= 0;
    },
    isMini: {
      get() {
        return this.mini == null
          ? localStorage.getItem("isMini") == "true"
          : this.mini;
      },
      set(val) {
        localStorage.setItem("isMini", val);
        this.mini = val;
      },
    },
  },
};
</script>
